export const RAZORPAY_CONFIG = {
  key_id: 'rzp_test_vmJG00z8Ft0Oto',
  key_secret: 'egsiIm9iAbikw0Tc9eT15q2Y',
  currency: 'INR',
  name: 'Checkout Builder',
  description: 'Product Purchase',
};

export const loadRazorpay = (): Promise<boolean> => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      console.error('Failed to load Razorpay SDK');
      resolve(false);
    };
    document.body.appendChild(script);
  });
};